class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.listMenuItems = document.querySelectorAll('nav ul.list-menu.list-menu--inline[role="list"] > li.list-menu__li-item:not(.list-menu__li-item--header-menu)');
    this.listMenuItems.forEach(item => item.addEventListener('mouseenter', (e) => {
      // document.dispatchEvent(new CustomEvent('headerMenu::leave'))
    }));
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

  customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.mainSumaryToggle = this.querySelector('summary');
    this.closeBtn = this.querySelector('.megamenu__close-btn');
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeaveHeader.bind(this));
    this.closeBtn.addEventListener('click', this.onCloseBtnClick.bind(this));
    this.timeout = undefined
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }

  onMouseEnter() {
    if (!this.mainDetailsToggle) return
    this.mainDetailsToggle.setAttribute('open', '')
  }

  onMouseLeaveHeader() {
    if (!this.mainDetailsToggle) return
    this.mainDetailsToggle.removeAttribute('open')
  }
  onCloseBtnClick() {
    this.mainSumaryToggle.click();
  }
}

  customElements.define('header-menu', HeaderMenu);

class HeaderMenuHelper {
  constructor() {
    this.lastOpen = undefined;
    document.addEventListener('headerMenu::select', this.onOpen.bind(this))
    document.addEventListener('headerMenu::leave', this.onLeave.bind(this))
  }
  onOpen(evt) {
    if(this.lastOpen == evt.detail) return

    if(!this.lastOpen) return this.lastOpen = evt.detail;

    if(this.lastOpen.ariaExpanded == 'true') this.lastOpen.click();

    this.lastOpen = evt.detail;
  }
  onLeave() {
    if(this.lastOpen && this.lastOpen.ariaExpanded == 'true') this.lastOpen.click();
  }
}

addEventListener('DOMContentLoaded', () => {
  const headerMenuHelper = new HeaderMenuHelper();
})
